// extracted by mini-css-extract-plugin
module.exports = {"subheading":"Tweets_subheading__QwC8U","buttonGroup":"Tweets_buttonGroup__6v0hW"};